module.exports = __webpack_public_path__ + "static/media/twitter-icon-hover.eb33fb36.svg";